import styled from 'styled-components'

import {
  backgroundTypes,
  borderTypes,
  boxModelTypes,
  cssTypes,
  displayTypes,
  linkTypes,
  textTypes,
} from '../types'
import { background, border, boxModel, css, display, link, text } from '../util'

/**
 * @namespace Anchor
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Anchor = styled.a`
  ${background};
  ${border};
  ${boxModel};
  ${css};
  ${display};
  ${link};
  ${text};
`

/**
 * @name defaultProps
 * @memberof Anchor
 * @desc Primitive's default properties
 */
Anchor.defaultProps = {
  borderWidth: [0],
  cursor: 'pointer',
  fontSize: 'baseFontSize',
  margin: [0],
  outline: 'none',
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof Anchor
 * @desc Primitive's prop type definitions
 */
Anchor.propTypes = {
  ...backgroundTypes,
  ...borderTypes,
  ...boxModelTypes,
  ...cssTypes,
  ...displayTypes,
  ...linkTypes,
  ...textTypes,
}

/** @component */
export default Anchor
